
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacidade",
      function () {
        return require("private-next-pages/privacidade/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacidade"])
      });
    }
  